import {Button, Stack} from '@mui/material';
import React from 'react';

import {EmptySearchState} from 'presentation/components';
import {ChatRoomsEnum} from 'presentation/constants';
import {useCallChatRoom} from 'presentation/pages/private';
import {translations} from 'presentation/translations-new';
import {Loading} from 'presentation/components/Loading/Loading';

const {noResults, emptyDescription, callToChat} = translations['pt-br'].commons;

export function GuideEmptyState() {
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	return (
		<Stack mt={3}>
			<EmptySearchState title={noResults} description={emptyDescription}>
				<Button
					size="large"
					onClick={async () => await callChatRoom(ChatRoomsEnum.APP)}
					disabled={callChatRoomIsLoading}
					endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}>
					{callToChat}
				</Button>
			</EmptySearchState>
		</Stack>
	);
}
